import { Title } from '@gerdau/hefesto';
import React, { useEffect } from 'react';
import { EHelpFileEndpoint } from '../../../services/HelpMenu';
import { Container } from './styles';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
import DownloadHelpButton from './DownloadHelpButton';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { IHelpItem } from '../../../store/ducks/help-center/types';

const HelpManuals: React.FC = () => {
  const dispatch = useDispatch();

  const { screenName } = getTaggingInformationScreen('help-manuals');

  const items: IHelpItem[] = [
    {
      title: 'Como eu posso utilizar o painel de gestão?',
      endpoint: EHelpFileEndpoint.DASHBOARD,
      taggingItemDescription: 'manuaisDeAjuda_painelDeGestao_download'
    },
    {
      title: 'Como eu posso comprar pelo Gerdau mais?',
      endpoint: EHelpFileEndpoint.PURCHASE,
      taggingItemDescription: 'manuaisDeAjuda_gerdauMais_download'
    },
    {
      title: 'Como eu posso gerenciar meus usuários e notificações?',
      endpoint: EHelpFileEndpoint.ACCESS_MANAGEMENT,
      taggingItemDescription: 'manuaisDeAjuda_usuarioENotificacao_download'
    },
    {
      title: 'Como eu posso gerenciar meus pedidos?',
      endpoint: EHelpFileEndpoint.ORDERS,
      taggingItemDescription: 'manuaisDeAjuda_meusPedidos_download'
    },
    {
      title: 'Como eu posso gerenciar minhas finanças?',
      endpoint: EHelpFileEndpoint.INVOICES,
      taggingItemDescription: 'manuaisDeAjuda_minhasFinancas_download'
    }
  ];

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName,
        page: window.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  return (
    <Container>
      <header data-testid="manuals-header">
        <Title level={2}>Manuais de ajuda?</Title>
        <p>
          Nesta página, disponibilizamos alguns tutorais com as principais
          dúvidas que você pode ter sobre a Gerdau mais.
        </p>
      </header>

      {items.map((item) => (
        <DownloadHelpButton item={item} key={item.title} />
      ))}
    </Container>
  );
};

export default HelpManuals;
